import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import MobileClickToPayWidget from './MobileClickToPayWidget';
import './MobileClickToPay.css';

// Entry point the mobile app's WebView loads for Click to Pay. The mobile
// app already owns order creation (its own init_pay path mints the mco), so
// it sends the EXISTING mco (+ amount, currency) in as query params. This
// page does the rest: creates the Click to Pay session, runs the card
// selection widget, and calls confirm_c2p_web itself to finalize the charge
// — then reports back to the app via the existing ercapp:// deep link
// (RedirectForMob / BackToAppModal).
const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const MobileClickToPay = () => {
  const history = useHistory();
  const query = useQuery();
  const mco = query.get('mco');
  const amount = query.get('amount');

  // source=clicktopay_mobile rides along on every hand-off (success, error,
  // and a manual close) so the mobile team can tell, from the /redirect URL
  // and the final ercapp:// deep link, that this callback came from the
  // Click to Pay mobile WebView flow specifically.
  const backToApp = (status, mcoValue) => {
    const params = new URLSearchParams({
      location: 'mobapp',
      status,
      source: 'clicktopay_mobile'
    });
    if (mcoValue) params.set('mco', mcoValue);
    history.push(`/redirect?${params.toString()}`);
  };

  if (!mco || !amount) {
    return (
      <div className="mobile_c2p_page mobile_c2p_error">
        <p>Missing order reference or amount.</p>
      </div>
    );
  }

  return (
    <div className="mobile_c2p_page">
      <MobileClickToPayWidget
        mco={mco}
        amount={amount}
        onSuccess={(mcoValue) => backToApp('success', mcoValue)}
        onError={() => backToApp('error', mco)}
        onClose={() => backToApp('cancelled', mco)}
      />
    </div>
  );
};

export default MobileClickToPay;
